window.addEventListener("scroll", function () {
  const header = document.querySelector(".header-wrapper");

  if (window.scrollY > 0) {
    header.classList.add("sticky-header");
  } else {
    header.classList.remove("sticky-header");
  }
});




document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth > 749) return;

  const blocks = document.querySelectorAll('.footer-block');

  blocks.forEach(block => {

    const heading = block.querySelector('.accordion-toggle');

    if (!heading) return;

    heading.addEventListener('click', function () {
      block.classList.toggle('active');
    });

  });

});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.rating-text span').forEach(function(el) {
        let rating = parseFloat(el.textContent);
        if (!isNaN(rating)) {
            el.textContent = rating.toFixed(1);
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.quick-add__submit').forEach(function(btn) {
        btn.textContent = 'BUY NOW';
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const bundle = document.querySelector(".bundle-builder");

  if (bundle) {
    document.querySelectorAll(".option_inner_span").forEach(function (el) {
      if (el.textContent.trim() === "24 packs each 4 weeks") {
        el.textContent = "28 packs each 4 weeks";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const trustSection = document.querySelector(".trust-section");
  if (!trustSection) return;

  const handle = window.location.pathname.split("/").pop();

  // Bundle product par hamesha show
  if (handle === "kite-protein-bar-bundle") {
    trustSection.style.display = "block";
    return;
  }

  // Baaki products ke liye sirf 24 variant par show
  function toggleTrustSection() {
    const variantTitle =
      document.querySelector(".product-form__input input[type='radio']:checked")?.value ||
      document.querySelector("select")?.value ||
      "";

    if (variantTitle.includes("24")) {
      trustSection.style.display = "block";
    } else {
      trustSection.style.display = "none";
    }
  }

  toggleTrustSection();

  document.addEventListener("change", toggleTrustSection);
  document.addEventListener("variant:change", toggleTrustSection);

});